import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import $ from 'jquery';
import { Row, Col, Panel, ListGroup, ListGroupItem, Glyphicon } from 'react-bootstrap';
import Button from './common/Button';
import CheckBox from './common/CheckBox';
import { isEmptyObject, isEmptyString } from '../validators/formValidators';
import { getFullName,
         getWorkflowTranslationHashTable,
         findBootstrapEnvironment,
         filteredRoute } from '../helpers/utils';

import { caseSetServerError,
         caseEditIdAction } from '../actions/caseActions';

import { userLogInLoadAction } from '../actions/userActions';

import { clientEditAction,
         clientNewAction,
         clientsAllAction,
         clientEditIdAction, 
         clientDeleteAction, 
         clientCasesEditAction } from './../actions/clientActions';

import Table, { getSquareColorTdProps } from './common/Table';
import ClientForm from './ClientForm';
import ClientAvatar from './common/ClientAvatar';
import ConfirmDialog from './common/ConfirmDialog';
import { getCaseStateColor } from '../helpers/colors';
import { casesUpdateColumnsAction } from './../actions/caseActions';
import LoadingProgressBar from './common/LoadingProgressBar';

class ClientEdit extends PureComponent {
    constructor(props) {
        super(props);
        this.close = this.close.bind(this);
        this.closeConfirm = this.closeConfirm.bind(this);
        this.archive = this.archive.bind(this);
        this.archiveConfirm = this.archiveConfirm.bind(this);
        this.getDashboardIntakeFields = this.getDashboardIntakeFields.bind(this);
        this.onResized = this.onResized.bind(this);
        this.onColumnResized = this.onColumnResized.bind(this);
        this.caseRowEdit = this.caseRowEdit.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.state = {
            permanentlyDelete: false,
            clientDialogOpen: false,
            clientDialogTitle: '',
            clientDialogCancel: () => {},
            dialogTitle: '',
            dialogText: '',
            dialogCancel: () => { this.setState({ dialogOpen: false }); },
            dialogConfirm: () => {},
            dialogOpen: false,
            dialogChildren: undefined,
        };
    }

    componentWillMount() {
        this.onResized();
        if (window) {
            window.addEventListener('resize', this.onResized);
        }
    }

    componentWillUnmount() {
        if (window) {
            window.removeEventListener('resize', this.onResized);
        }
    }

    componentDidMount() {
        switch (this.props.editType) {
        case 'new':
            this.props.dispatch(clientNewAction());
            this.setState({
                clientDialogOpen: true,
                clientDialogTitle: 'New Contact',
                clientDialogCancel: () => {
                    this.close();
                    this.setState({ clientDialogOpen: false });
                },
            });

            break;

        case 'edit':
            this.onEdit();
            break;

        default:
            break;
        }

        if (!this.props.currentConfig) {
            this.props.dispatch(userLogInLoadAction())
                .catch((error) => {
                    console.error(new Error().stack, error);
                    this.props.dispatch(caseSetServerError(error));
                });
        }
    }

    onResized(evt) {
        let size = findBootstrapEnvironment();
        if (size === 'xs' || size === 'sm' || size === 'md') {
            size = 'xs';
        }

        this.setState({ size });
    }

    onColumnResized(newHeaders) {
        this.props.dispatch(casesUpdateColumnsAction(newHeaders))
            .catch((error) => {
                console.error(new Error().stack, error);
                this.props.dispatch(caseSetServerError(error));
            });
    }

    onEdit() {
        if (isEmptyObject(this.props.clients.current) || isEmptyObject(this.props.cases)) {
            if (!this.props.clients.loadingCurrent && this.props.params.id) {
                this.props.dispatch(clientEditIdAction(this.props.params.id, this.props.clients.current || {}))
                    .then((result) => {
                        if (isEmptyObject(result.data)) {
                            this.props.dispatch(clientsAllAction());
                            browserHistory.push('/client/all');
                            return;
                        }

                        this.props.dispatch(clientEditAction(result.data.client));
                        this.props.dispatch(clientCasesEditAction(result.data.cases));
                    })
                    .catch((error) => {
                        console.error(new Error().stack, error);
                        this.props.dispatch(caseSetServerError(error));
                    });
            }
        }
    }

    getDashboardIntakeFields() {
        const fields = getWorkflowTranslationHashTable(this.props.currentConfig,
                                                       this.props.currentClient && {client: this.props.currentClient},
                                                       {},
                                                       (type, table, field) =>
                                                                this.props.currentClient &&
                                                                (!this.props.currentClient['ClientType'] || this.props.currentClient['ClientType'] === type) &&
                                                                (field === undefined || !['FirstName', 'LastName', 'MiddleName', 'Phone', 'Email', 'ClientType'].includes(field.name)) &&
                                                                (field === undefined || (field.type !== 'Hidden' || field.name === 'CreatedDate')) &&
                                                                (field === undefined || (!isEmptyString(this.props.currentClient[field.name]) && this.props.currentClient[field.name] !== '{}')) &&
                                                                (field === undefined || !field.nested),
                                                       true,
                                                       'client');

        return fields;
    }

    close() {
        this.setState({ dialogOpen: false });
        const route = filteredRoute('/client/all', this.props.clients.filter);
        this.props.dispatch(clientNewAction());
        this.props.dispatch(clientsAllAction());
        browserHistory.push(route);
    }

    closeConfirm(evt) {
        evt.preventDefault();
        if (this.props.clients.savingNeeded) {
            this.setState({
                dialogTitle: 'Unsaved data',
                dialogText: 'Do you want to lose current changes?',
                dialogCancel: () => {this.setState({ dialogOpen: false })},
                dialogConfirm: () => {this.close()},
                dialogOpen: true,
                dialogChildren: undefined,
            });

        } else {
            this.close();
        }
    }

    archiveConfirm() {
        let currentClient = this.props.currentClient;
        let title = 'Archive?';
        let text = 'Do you really want to archive the current record?';
        if (!isEmptyString(currentClient['deleted_at'])) {
            title = 'Unarchive?';
            text = 'Do you want to unarchive the current record?';
        }

        let archiveConfirmFun = () => {
            this.setState({
                dialogTitle: title,
                dialogText: text,
                dialogCancel: () => {this.setState({dialogOpen: false})},
                dialogConfirm: () => {
                    this.archive();
                    this.setState({dialogOpen: false})
                },
                dialogOpen: true,
                permanentlyDelete: false,
                dialogChildren: (
                <Row>
                    <br />
                    <Col xs={12}>
                    <CheckBox field={{
                                  name: 'permanentlyDeleteCheckbox'
                              }}
                              label="Permanently delete"
                              help="If checked, the record will be permanently deleted."
                              onChange={elem => {
                                  this.setState({permanentlyDelete: !this.state.permanentlyDelete});
                              }} />
                    </Col>
                </Row>
                )
            });
        }

        archiveConfirmFun();
    }

    archive() {
        const currentClient = this.props.currentClient;
        const id = parseInt(currentClient.id, 10);
        this.setState({
            loading: true
        });

        this.props.dispatch(clientDeleteAction(id, this.state.permanentlyDelete))
            .then((result) => {
                this.close();
                this.setState({
                    loading: false
                });
            })
            .catch((error) => {
                console.error(new Error().stack, error);
                this.props.dispatch(caseSetServerError(error));
                this.setState({
                    loading: false
                })
            });
    }

    caseRowEdit(rowIndex, currentCase) {
        const id = parseInt(currentCase.id, 10);
        this.props.dispatch(caseEditIdAction(id, currentCase));
        $('html, body').animate({
            scrollTop: $("#mainNavBar").offset().top
        }, 0);
        
        browserHistory.push(`/case/edit/intake/${id}`);
    }


    render() {
        const {
            submitting,
            loadingCurrent,
            currentClient = {},
            clientType,
            routes,
            editType,
            cases = [],
            caseHeaders = [],
        } = this.props;

        const loading = loadingCurrent;
        let states = [];
        if (this.props.states) {
            states = this.props.states.map((value) => {
                return {label: value.type};
            });
        }

        const clientFields = this.getDashboardIntakeFields();
        const size = this.state.size;
        let activeRoute = routes;
        if (editType !== 'new' && activeRoute) {
            activeRoute = routes[routes.length - 1].path;
            let slash = activeRoute.indexOf('/');
            if (slash !== -1) {
                activeRoute = activeRoute.substring(0, slash);
            }
        }

        let displayName = getFullName(currentClient);
        if (currentClient['deleted_at']) {
            displayName += ' - ARCHIVED';
        }

        return (
            <div className="ct-casepage">
            {this.props.loadingCurrent && <Row style={{marginRight: size !== 'xs' ? 55 : 0, marginTop: -15, marginBottom: 0}}><LoadingProgressBar loading /></Row>}
                <div className="ct-pagehead">
                    <div className="ct-pagehead-main">
                        <div className="ct-pagehead-title"><h1>{displayName}</h1></div>
                        <p className="ct-pagehead-sub">{`Contact Info (${clientType})`}</p>
                    </div>
                    <div className="ct-pagehead-actions">
                        <Button onClick={this.closeConfirm}
                                disabled={submitting}
                                icon="remove"
                                label="Close"
                                tooltip="Return to viewing all records"
                                tooltipPosition="bottom"
                        />
                    </div>
                </div>
                <Row>
                    <Col xs={12} md={5}>
                        <Row>
                        <Col xs={12}>
                            <Panel data-hj-whitelist style={{marginLeft: 15, marginRight: size !== 'xs' ? -15 : 15, marginTop: 3}} header={`Contact Info (${clientType})`}>
                                <Row xs={12}>
                                    <Col xs={2} style={{textAlign: 'center'}}>
                                        <ClientAvatar
                                            client={currentClient}
                                            size={size !== 'xs' ? 70 : 50}
                                            mobile={size === 'xs'}
                                            editable={!!currentClient['id']}
                                            deleted={!isEmptyString(currentClient['deleted_at'])}
                                        />
                                    </Col>
                                    <Col xs={6}>
                                        <h6 style={{margin: 2}}><b>{displayName}</b></h6>
                                        <h6 style={{margin: 2}}><Glyphicon glyph="phone"/> {currentClient['Phone']}</h6>
                                        <h6 style={{margin: 2}}><Glyphicon glyph="envelope"/> {currentClient['Email']}</h6>
                                    </Col>
                                </Row>
                                <hr style={{marginTop: 10}} />
                                <Row className="row-display-flex">
                                    <Col xs={12} md={6} style={{paddingLeft: 15, marginTop: -15}}>
                                        <ListGroup>
                                        {clientFields.map((field, index) => {
                                            let value = typeof(field.value) === 'string' ? field.value : JSON.stringify(field.value);
                                            return (index < clientFields.length / 2) && (
                                                <ListGroupItem style={{border: '0px none', textOverflow: 'ellipsis', overflow: 'hidden'}} header={(<h6>{field.props && field.props.label}</h6>)}>{value || <span>&nbsp;</span>}</ListGroupItem>
                                            );
                                        })}
                                        </ListGroup>
                                    </Col>
                                    <Col xs={12} md={6} style={{paddingLeft: 15, marginTop: -15}}>
                                        <ListGroup>
                                        {clientFields.map((field, index) => {
                                            let value = typeof(field.value) === 'string' ? field.value : JSON.stringify(field.value);
                                            return (index >= clientFields.length / 2) && (
                                                <ListGroupItem style={{border: "0 none", textOverflow: 'ellipsis', overflow: 'hidden'}} header={(<h6>{field.props && field.props.label}</h6>)}>{value || <span>&nbsp;</span>}</ListGroupItem>
                                            );
                                        })}
                                        </ListGroup>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: '-15px' }}>
                                <Col xs={6}>
                                    <Button onClick={() => {
                                                this.setState({
                                                    clientDialogOpen: true,
                                                    clientDialogTitle: 'Edit Contact Details',
                                                    clientDialogCancel: () => {
                                                        this.props.dispatch(clientEditIdAction(this.props.params.id));
                                                        this.setState({ clientDialogOpen: false });
                                                    },
                                                });
                                            }}
                                            disabled={loading}
                                            style={{width: 100, marginTop: '15px', float: 'left', marginRight: '15px'}}
                                            icon="edit"
                                            label="Edit"
                                            bsStyle="link"
                                            tooltip="Edit Contact Details"
                                    />
                                    <Button onClick={this.archiveConfirm}
                                            disabled={submitting}
                                            style={{width: 100, marginTop: '15px', float: 'left'}}
                                            icon="inbox"
                                            bsStyle="link"
                                            label={!isEmptyString(this.props.currentClient['deleted_at']) ? 'Unarchive ...' : 'Archive ...'}
                                            tooltip="Archive or permanently delete current record"
                                            tooltipPosition="top"
                                    />
                                </Col>
                                </Row>
                            </Panel>
                        </Col>
                        </Row>
                    </Col>
                    <Col xs={12} md={6} style={{ marginTop: size !== 'xs' ? 40 : 0, marginLeft: size !== 'xs' ? 30 : 0 }}>
                    <Row>
                    <Col xs={12}>
                        <Panel header={`Cases (${!cases ? 0 : cases.length})`}
                               data-hj-whitelist
                                style={{
                                    marginLeft: size !== 'xs' ? 18 : 15,
                                    marginRight: size !== 'xs' ? 0 : 15,
                                    marginTop: 0,
                                    paddingBottom: 0,
                                }}
                        >
                        <Table headers={caseHeaders}
                               rows={cases}
                               onColumnResized={this.onColumnResized}
                               editRow={this.caseRowEdit}
                               editBsStyle="link"
                               buttonsWidth={20}
                               filterable={false}
                               loading={loading}
                               defaultPageSize={10}
                               getTdProps={getSquareColorTdProps('action', (rowInfo, config) => getCaseStateColor(rowInfo && rowInfo.original && rowInfo.original['notes'] && rowInfo.original['notes']['CaseState'], config))}
                        />
                        </Panel>
                    </Col>
                    </Row>
                    </Col>
                </Row>
                <ClientForm showAsDialog
                            dialogConfirm={() => {
                                this.onEdit();
                                this.setState({ clientDialogOpen: false });
                            }}
                            dialogOpen={this.state.clientDialogOpen}
                            dialogTitle={this.state.clientDialogTitle}
                            dialogCancel={this.state.clientDialogCancel}
                />
                <ConfirmDialog title={this.state.dialogTitle}
                               text={this.state.dialogText}
                               cancel={this.state.dialogCancel}
                               confirm={this.state.dialogConfirm}
                               open={this.state.dialogOpen}
                               confirmButton={this.state.dialogSaveButton}
                               warning
                >
                {this.state.dialogChildren}
                </ConfirmDialog>
            </div>
        );
    }
}

ClientEdit.propTypes = {
    fields: PropTypes.object.isRequired,
    serverError: PropTypes.string,
    submitting: PropTypes.bool.isRequired,
    loadingCurrent: PropTypes.bool.isRequired
};

const mapStateToProps = (state, ownProps) => {
    const currentClient = state.clients.current;
    const currentConfig = state.user.config;
    const clientFormType = state.user.clientFormType;
    const loggedIn = state.user.loggedIn;
    let clientType;    
    if (currentConfig) {
        const client = currentConfig.client;
        if (ownProps.renderFormEditor && clientFormType) {
            clientType = clientFormType;
        } else if (currentClient['ClientType'] && client && client.find(v => v.type === currentClient['ClientType'])) {
            clientType = currentClient['ClientType'];
        } else if (client.length > 0) {
            clientType = client[0].type;
        }
    }

    const cases = state.clients.currentCases;
    const casesRefreshNeeded = state.cases.refreshNeeded;
    const caseHeaders = currentConfig && currentConfig.caseHeaders;

    return {
        currentClient,
        cases,
        clients: state.clients,
        casesRefreshNeeded,
        caseHeaders,
        currentConfig,
        clientType,
        isSavingNeeded: state.cases.savingNeeded,
        loadingCurrent: state.clients.loadingCurrent,
        loggedIn,
    };
};

export default connect(mapStateToProps)(ClientEdit);
